import React, { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "../../components/ui/Input";
import { ReleaseTable } from "../../components/admin/ReleaseTable";
import { useAdminReleases } from "../../hooks/useAdminApi";
import { debounce } from "../../utils";

export const AdminReleasesPage: React.FC = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const { data } = useAdminReleases(page, limit, search);

  const debouncedSearch = debounce((value: string) => {
    setSearch(value);
    setPage(1);
  }, 250);

  const total = data?.meta.total;

  return (
    <section>
      <header className="mb-6">
        <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground font-medium mb-2">
          Releases
        </p>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          Conteúdo publicado
        </h1>
        <p className="mt-1.5 text-sm text-muted-foreground">
          Edite o texto, regenere com IA ou remova versões individualmente.
          {typeof total === "number" && (
            <>
              {" "}
              <span className="text-foreground font-medium tabular-nums">{total}</span>{" "}
              {total === 1 ? "release" : "releases"} no total.
            </>
          )}
        </p>
      </header>

      <div className="mb-5 relative max-w-md">
        <Search
          className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none"
          aria-hidden="true"
        />
        <Input
          type="search"
          placeholder="Buscar por tag ou conteúdo"
          onChange={(e) => debouncedSearch(e.target.value)}
          className="pl-10"
        />
      </div>

      <ReleaseTable
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        search={search}
      />
    </section>
  );
};
